import * as React from "react";

import { OneTimePasswordSendCodeFormUi } from "../../one-time-password";

export const StepSendCode: React.FunctionComponent = () => {
  return (
    <section className="bbnt-common-join-drawer-fragment one-time-password-step step-send-code">
      <img className="rewards-fancy-title-image" alt="REWARDS" />
      <h1 className="main-drawer-title">{`Sign in with a one-time code`}</h1>

      <OneTimePasswordSendCodeFormUi />
    </section>
  );
};
